export function _splitPath(path: string) {
  return path
    .split(/\.|\[|\]/)
    .filter((str) => !!str)
    .reverse();
}
